import {
  CollectionLockup,
  CollectionLockupContent,
  CollectionLockupTitle,
  MultiTraitTooltip,
} from "@opensea/app-kit"
import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import {
  ItemAvatar,
  ItemContent,
  ItemDescription,
  ItemTitle,
  TextOverflowTooltip,
  tableRowSizeVariants,
  useTable,
} from "@opensea/ui-kit"
import { Item } from "../../../../../components/Item"
import { CancelOrderTableRowItem_orderFragment } from "./CancelOrderTableRowItem.fragment"

type Props = {
  order: FragmentOf<typeof CancelOrderTableRowItem_orderFragment>
}

export const CancelOrderTableRowItem = ({ order: orderKey }: Props) => {
  const order = readFragment(CancelOrderTableRowItem_orderFragment, orderKey)
  const { size } = useTable()
  const { image } = tableRowSizeVariants({ size })

  const { collection, item, side, type, traitIdentifier, traitIdentifiers } =
    order
  return side === "OFFER" &&
    (type === "CRITERIA_COLLECTION" || type === "CRITERIA_TRAIT") ? (
    <Item variant="unstyled">
      <ItemAvatar className={image()} src={collection.imageUrl} />
      <ItemContent>
        <CollectionLockup collection={collection} size={size}>
          <CollectionLockupContent>
            <CollectionLockupTitle color="text-secondary" weight="regular" />
          </CollectionLockupContent>
        </CollectionLockup>
        {traitIdentifier ? (
          <ItemDescription>
            {traitIdentifier.traitType}: {traitIdentifier.value}
          </ItemDescription>
        ) : traitIdentifiers ? (
          <ItemDescription>
            <MultiTraitTooltip traits={traitIdentifiers} />
          </ItemDescription>
        ) : null}
      </ItemContent>
    </Item>
  ) : item ? (
    <Item variant="unstyled">
      <ItemAvatar className={image()} src={item.imageUrl} />
      <ItemContent>
        <TextOverflowTooltip>
          <ItemTitle>{item.name || `#${item.tokenId}`}</ItemTitle>
        </TextOverflowTooltip>
        <CollectionLockup collection={collection} size={size}>
          <CollectionLockupContent>
            <CollectionLockupTitle color="text-secondary" weight="regular" />
          </CollectionLockupContent>
        </CollectionLockup>
      </ItemContent>
    </Item>
  ) : null
}
